import { Injectable } from '@angular/core';
import { IImage } from '../interfaces/definitions';

import { HttpClient } from '@angular/common/http';
import { NgMediaConfigService } from './ng-media-config.service';

@Injectable()
export class RequestsService {
  constructor(private http: HttpClient, private config: NgMediaConfigService) {}

  public get API() {
    return this.config.API.value;
  }

  /**
   * Gets the media object based on popularity, or based on user search
   */
  public GetInitialMedias() {}

  public DeleteItem(id: string) {
    return this.http.delete(`${this.API}/ngmedia/delete/${id}`).toPromise();
  }
  public UpdateImage(image: IImage) {
    return this.http
      .post(`${this.API}/ngmedia/file/${image.id}`, {
        ...image
      })
      .toPromise();
  }

  public DirectUpload(formData, headers) {
    return this.http.post(this.API + '/ngmedia/upload-direct', formData, {
      headers,
      reportProgress: true,
      observe: 'events'
    });
  }
}
